<template>
    <v-container>
        <v-card class="mb-10">
            <v-card-title class="card-title">Season Form</v-card-title>
        </v-card>
        <v-form :readonly="readOnly">
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        v-model="season.year"
                        label="Year"
                        type="Number"
                        :clearable="clearable"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-model="season.name"
                        label="Name"
                        :clearable="clearable"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <date-time-picker
                        :date-label="'From Date'"
                        :date="startDate"
                        @setDate="setStartDate"
                    />
                </v-col>
                <v-col cols="4">
                    <date-time-picker
                        :date-label="'To Date'"
                        :date="endDate"
                        @setDate="setEndDate"
                    />
                </v-col>
                <v-col cols="4">
                    <v-select
                        v-model="season.type"
                        :items="seasonType"
                        :rules="rules"
                        menu-props="auto"
                        label="Type"
                        hide-details
                    />
                </v-col>
            </v-row>
        </v-form>
        <div v-if="mode !== 'show'" class="submit-button-wrapper">
            <v-btn :loading="loading" class="mx-2 white--text" :disabled="shouldDisableSubmit()" large color="black" @click="onSubmit">
                Submit
            </v-btn>
            <v-btn class="mx-2 white--text" large color="red" @click="$router.go(-1)">
                Cancel
            </v-btn>
        </div>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import seasonService from '@/services/season'
    import Alert from '@/components/Alert'
    import DateTimePicker from '@/components/DateTimePicker'
    import momentTimezone from 'moment-timezone'

    export default {
        name: 'SeasonForm',
        components: { Alert, DateTimePicker },
        data: () => {
            return {
                showAlert: false,
                message: null,
                type: null,
                mode: null,
                readOnly: false,
                clearable: true,
                loading: false,
                startDate: null,
                endDate: null,
                startTime: null,
                endTime: null,
                season: {
                },
                seasonId: null,
                rules: [
                    v => !!v || 'Field is required'
                ],
                seasonType: ['winter', 'summer']
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            this.seasonId = this.$route.params.seasonId
            if (this.seasonId) {
                seasonService.getSeason(this.seasonId).then(resp => {
                    this.season = resp.data
                    this.startDate = momentTimezone(this.season.startDate).tz('Europe/Athens').format('YYYY-MM-DD').toString()
                    if (this.season.endDate) {
                        this.endDate = momentTimezone(this.season.endDate).tz('Europe/Athens').format('YYYY-MM-DD').toString()
                    }
                })
            }
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            shouldDisableSubmit() {
                return !this.season.year || !this.startDate || !this.season.type
            },
            setStartDate(date) {
                this.startDate = date
            },
            setEndDate(date) {
                this.endDate = date
            },
            onEdit() {
                this.$router.push(`/seasons/${this.seasonId}/edit`)
            },
            createSeason() {
                this.loading = true
                seasonService.createSeason(this.season).then(seasonResponse => {
                    if (seasonResponse.id) {
                        this.seasonId = seasonResponse.id
                    }
                    this.loading = false
                    this.$router.push(`/seasons`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            editSeason() {
                this.loading = true
                seasonService.updateSeason(this.seasonId, this.season).then(seasonResponse => {
                    if (seasonResponse.id) {
                        this.seasonId = seasonResponse.id
                    }
                    this.loading = false
                    this.$router.push(`/seasons`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            async onSubmit() {
                this.season.startDate = momentTimezone(this.startDate).tz('Europe/Athens').startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                if (this.endDate) {
                    this.season.endDate = momentTimezone(this.endDate).tz('Europe/Athens').endOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                }
                if (this.mode === 'edit') {
                    this.editSeason()
                } else if (this.mode === 'create') {
                    this.createSeason()
                }
            }
        }

    }
</script>
<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.img-preview {
    max-width: 70%;
    margin: 0 auto;
}

.image-input {
    padding: 20px;
    width: 100%;
    border-style: groove;
    border: #D3D3D3 solid 2px;
    border-radius: 15px 50px;
    margin-top: 1vh;
}

.green-border {
    border-color: green;
}

.delete-btn {
    display: flex;
    justify-content: flex-end;
}
</style>
